export default __webpack_public_path__ + "static/bpi-5157f28a99a333b5de817e529d9d47bd.svg";